import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { initTracking } from '../../services/tracking';

const CookiePreferences = ({ visible, onHide }) => {
  const handleAccept = () => {
    try {
      localStorage.setItem('cookie_consent', 'accepted');
    } catch {}
    if (process.env.NODE_ENV === 'production') {
      initTracking();
    }
    onHide?.();
  };

  const handleRevoke = () => {
    try {
      localStorage.setItem('cookie_consent', 'rejected');
    } catch {}
    onHide?.();
    // Para asegurar que tracking se detenga, recargamos la SPA
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  const footer = (
    <div className="flex gap-2 justify-content-end">
      <a href="/privacidad" className="p-button p-button-text">Más información</a>
      <Button label="Revocar" icon="pi pi-ban" className="p-button-danger" onClick={handleRevoke} />
      <Button label="Aceptar" icon="pi pi-check" onClick={handleAccept} />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Preferencias de cookies"
      style={{ width: '100%', maxWidth: '640px' }}
      footer={footer}
    >
      <div className="text-700">
        <p>
          Puedes gestionar tu consentimiento para cookies analíticas y de marketing.
          Si seleccionas "Revocar", las tecnologías de seguimiento dejarán de funcionar
          y el aviso de cookies volverá a mostrarse en tu próxima visita.
        </p>
        <p>
          Consulta nuestra <a href="/privacidad" className="text-primary">Política de Privacidad</a>
          para más detalles sobre tipos de cookies y finalidades.
        </p>
      </div>
    </Dialog>
  );
};

export default CookiePreferences;